/* Source S30 carousel timings and maintenance thresholds, with owned teardown. */
(() => {
  'use strict';
  if (window.NarwalS30) { window.NarwalS30.init(document); return; }
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 768px)');
  const instances = new Map();
  const media = new Map();
  const carouselSelector = '.ndev-dx9-clean-cut, .ndev-dx9-card-slide, .ndev-dx9-clean-slide, .ndev-dx9-battery-life, .ndev-dx9-family-photo';
  let scheduled = 0;
  const clamp = n => Math.max(0, Math.min(1, n));
  const visit = (scope, selector, fn) => {
    if (scope instanceof Element && scope.matches(selector)) fn(scope);
    scope.querySelectorAll(selector).forEach(fn);
  };
  function carousel(root) {
    if (instances.has(root) || !window.Swiper) return;
    const container = root.querySelector('[node-name="swiper"]');
    if (!container) return;
    const card = root.matches('.ndev-dx9-card-slide');
    const clean = root.matches('.ndev-dx9-clean-slide');
    const automatic = card || clean;
    const duration = card ? 3000 : 4000;
    const tabs = [...root.querySelectorAll(card ? '[node-name="thumb"]' : '[node-name="tab"]')];
    const bars = [...root.querySelectorAll('[node-name="bar"]')];
    const tabGroup = root.querySelector('[node-name="tabs"]');
    const count = root.querySelector('[node-name="num"]');
    const events = new AbortController();
    const previousAttributes = new Map();
    const remember = (el, name, value) => {
      if (!previousAttributes.has(el)) previousAttributes.set(el, new Map());
      const map = previousAttributes.get(el); if (!map.has(name)) map.set(name, el.getAttribute(name));
      if (value === null) el.removeAttribute(name); else el.setAttribute(name, value);
    };
    let swiper;
    let frame = 0;
    let elapsed = 0;
    let previousTime = 0;
    let inView = false;
    let hover = false;
    let focus = false;
    let userPaused = false;
    let control;
    let disposed = false;
    function drawProgress(value) {
      if (card) bars.forEach((bar, index) => { bar.style.transform = `scaleX(${index === swiper?.realIndex ? value : 0})`; });
      if (clean && bars[0]) bars[0].style.strokeDashoffset = String((1 - value) * 163.358);
    }
    function canRun() { return automatic && !disposed && !userPaused && !motion.matches && inView && !document.hidden && !hover && !focus; }
    function stop() { cancelAnimationFrame(frame); frame = 0; previousTime = 0; }
    function tick(time) {
      frame = 0;
      if (!canRun()) { previousTime = 0; return; }
      if (previousTime) elapsed += Math.min(100, time - previousTime);
      previousTime = time;
      drawProgress(clamp(elapsed / duration));
      if (elapsed >= duration) {
        elapsed = 0; previousTime = 0;
        if (card) swiper.slideTo((swiper.realIndex + 1) % swiper.slides.length);
        else swiper.slideNext();
      }
      if (!frame) frame = requestAnimationFrame(tick);
    }
    function sync() {
      if (swiper) swiper.params.speed = motion.matches ? 0 : 300;
      if (control) {
        const paused = userPaused || motion.matches;
        control.hidden = motion.matches;
        control.setAttribute('aria-pressed', String(paused));
        control.setAttribute('aria-label', paused ? 'Воспроизвести карусель' : 'Приостановить карусель');
        control.textContent = paused ? 'Воспроизвести' : 'Приостановить';
      }
      if (!canRun()) stop(); else if (!frame) frame = requestAnimationFrame(tick);
    }
    function change() {
      if (!swiper) return;
      const current = swiper.realIndex;
      tabs.forEach((tab, index) => {
        tab.classList.toggle('active', index === current);
        remember(tab, 'aria-pressed', String(index === current));
      });
      tabGroup?.classList.toggle('last', current === 1);
      if (count) count.textContent = String(current + 1).padStart(2, '0');
      elapsed = 0; previousTime = 0; drawProgress(0);
      window.$narwal?.emit?.('init.media.scroll');
      sync();
    }
    // These five containers are exclusively owned by this source-specific adapter.
    container.swiper?.destroy(true, true);
    swiper = new window.Swiper(container, {
      slidesPerView: 'auto', initialSlide: 0, speed: motion.matches ? 0 : 300,
      loop: clean, centeredSlides: clean && mobile.matches,
      ...(automatic ? { navigation: { nextEl: root.querySelector('.next-btn'), prevEl: root.querySelector('.prev-btn') } } : {}),
      on: { slideChange: () => queueMicrotask(change) }
    });
    tabs.forEach((tab, index) => {
      remember(tab, 'role', 'button'); remember(tab, 'tabindex', '0');
      tab.addEventListener('click', () => swiper.slideTo(index), { signal: events.signal });
      tab.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); swiper.slideTo(index); }
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); const next = (index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
          tabs[next].focus({ preventScroll: true }); swiper.slideTo(next);
        }
      }, { signal: events.signal });
    });
    for (const [selector, label, direction] of [['.next-btn', 'Следующий слайд', 1], ['.prev-btn', 'Предыдущий слайд', -1]]) {
      root.querySelectorAll(selector).forEach(button => {
        remember(button, 'aria-label', label); remember(button, 'tabindex', '0'); remember(button, 'role', 'button');
      });
    }
    remember(container, 'tabindex', '0');
    remember(container, 'role', 'group');
    remember(container, 'aria-roledescription', 'carousel');
    remember(container, 'aria-label', 'Характеристики продукта. Используйте клавиши со стрелками влево и вправо для смены слайдов.');
    container.addEventListener('keydown', event => {
      if (event.target !== container) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); event.stopPropagation();
        event.key === 'ArrowRight' ? swiper.slideNext() : swiper.slidePrev();
      }
    }, { signal: events.signal });
    if (automatic) {
      control = document.createElement('button'); control.type = 'button'; control.className = 'nwb-s30-autoplay-toggle';
      root.append(control);
      control.addEventListener('click', event => { event.stopPropagation(); userPaused = !userPaused; if (!userPaused) { hover = false; focus = false; } sync(); }, { signal: events.signal });
      root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hover = true; sync(); } }, { signal: events.signal });
      root.addEventListener('pointerleave', () => { hover = false; sync(); }, { signal: events.signal });
      root.addEventListener('focusin', () => { focus = true; sync(); }, { signal: events.signal });
      root.addEventListener('focusout', () => queueMicrotask(() => { focus = root.contains(document.activeElement); sync(); }), { signal: events.signal });
    }
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { inView = entries[0].isIntersecting; sync(); }) : null; if (observer) observer.observe(root); else inView = true;
    root.dataset.nwbCarouselReady = 'true'; root.setAttribute('data-nwb-s30-motion', '');
    instances.set(root, {
      sync,
      resize() { if (clean) swiper.params.centeredSlides = mobile.matches; swiper.update(); sync(); },
      destroy() {
        disposed = true; stop(); events.abort(); observer?.disconnect(); control?.remove(); swiper.destroy(true, true);
        previousAttributes.forEach((values, el) => values.forEach((value, name) => value === null ? el.removeAttribute(name) : el.setAttribute(name, value)));
        bars.forEach(bar => { bar.style.removeProperty('transform'); bar.style.removeProperty('stroke-dashoffset'); });
        root.removeAttribute('data-nwb-carousel-ready'); root.removeAttribute('data-nwb-s30-motion'); instances.delete(root);
      }
    });
    change(); sync();
  }
  function maintenance(root) {
    if (instances.has(root)) return;
    const title = root.querySelector('[node-name="title"]');
    const param = root.querySelector('[node-name="param"]');
    const overlay = root.querySelector('[node-name="overlay"]');
    const images = [...root.querySelectorAll('[node-name="pcImage"], [node-name="mbImage"]')];
    const oldOpacity = images.map(image => image.style.opacity);
    function sync() {
      const percent = Math.round(clamp((innerHeight - root.getBoundingClientRect().top) / innerHeight) * 100);
      title?.classList.toggle('show', motion.matches || percent > 30);
      param?.classList.toggle('show', motion.matches || percent > 80);
      overlay?.classList.toggle('show', motion.matches || percent > 80);
      images.forEach(image => { image.style.opacity = motion.matches ? '1' : String(clamp((percent - 25) / 75)); });
    }
    root.dataset.nwbDetailReady = 'true'; root.setAttribute('data-nwb-s30-motion', '');
    instances.set(root, { sync, resize: sync, destroy() {
      images.forEach((image, index) => { image.style.opacity = oldOpacity[index]; });
      [title, param, overlay].forEach(el => el?.classList.add('show'));
      root.removeAttribute('data-nwb-detail-ready'); root.removeAttribute('data-nwb-s30-motion'); instances.delete(root);
    } }); sync();
  }
  function legacyMedia(video) {
    if (media.has(video)) return;
    let owner = video.parentElement;
    while (owner && owner.id !== 'main-content' && ![...owner.classList].some(name => name.startsWith('ndev-dx9-'))) owner = owner.parentElement;
    if (!owner || owner.id === 'main-content') return;
    let visible = false;
    let mediaPrepared = false;
    if (!video.poster && video.dataset.poster) video.poster = video.dataset.poster;
    video.muted = true;
    video.playsInline = true;
    video.removeAttribute('autoplay');
    function syncVideo() {
      if (!video.isConnected) { media.get(video)?.destroy(); return; }
      if (visible && !motion.matches && !document.hidden && video.getClientRects().length && getComputedStyle(video).visibility !== 'hidden') {
        if (!mediaPrepared) {
          video.querySelectorAll('source[data-src]').forEach(source => { if (!source.getAttribute('src')) source.src = source.dataset.src; });
          video.load(); mediaPrepared = true;
        }
        video.play()?.catch(() => {});
      }
      else video.pause();
    }
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting; syncVideo(); }) : null;
    if (observer) observer.observe(video); else visible = true;
    video.addEventListener('loadeddata', syncVideo);
    video.addEventListener('canplay', syncVideo);
    media.set(video, { sync: syncVideo, destroy() { observer?.disconnect(); video.removeEventListener('loadeddata', syncVideo); video.removeEventListener('canplay', syncVideo); video.pause(); media.delete(video); } });
    syncVideo();
  }
  function init(scope = document) { visit(scope, carouselSelector, carousel); visit(scope, '.ndev-dx9-free-maintenance', maintenance); visit(scope, 'video[node-name=desktop], video[node-name=mobile]', legacyMedia); }
  function destroy(scope) { visit(scope, '[data-nwb-s30-motion]', root => instances.get(root)?.destroy()); visit(scope, 'video[node-name=desktop], video[node-name=mobile]', video => media.get(video)?.destroy()); }
  function sync() { scheduled = 0; instances.forEach((controller, root) => root.isConnected ? controller.sync() : controller.destroy()); media.forEach(controller => controller.sync()); }
  document.addEventListener('visibilitychange', sync);
  window.addEventListener('scroll', () => { if (!scheduled) scheduled = requestAnimationFrame(sync); }, { passive: true });
  window.addEventListener('resize', () => instances.forEach(controller => controller.resize()), { passive: true });
  motion.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', event => { init(event.target); event.target.querySelectorAll('.narwal-fade-in-out').forEach(el => el.classList.add('finish')); });
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  window.NarwalS30 = { init, destroy, get count() { return instances.size; }, get mediaCount() { return media.size; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
})();
